import useAuth from '../../hooks/useAuth';
import ProperDashboard from './components/ProperDashboard';
import ClassicInternalUserDashboard from './components/classic/InternalUserDashboard';

// Dashboard anterior (versión en producción antes del rediseño v2). Se
// conserva en /dashboard/classic, dentro del menú Dashboard.
const DashboardClassic = () => {
  const { getUserRealm } = useAuth();
  return getUserRealm().toLowerCase() === 'proper' ? (
    <ProperDashboard />
  ) : (
    <ClassicInternalUserDashboard />
  );
};

export default DashboardClassic;
